import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { loadInventoryLocations } from '@sophocles/features/inventory/inventoryLocations/api';

function InventoryLocationAutocomplete({
  name,
  value,
  size,
  error,
  helperText,
  required,
  fullWidth,
  disabled,
  onChange,
  onBlur,
  label: labelProp,
  sx = [],
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const label = labelProp ?? t('inventory.inventoryLocation');

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);

  const saveDataToState = inputData => {
    const newData = inputData.map(row => {
      const label = `${row.name}. ${row.description}`;
      return {
        label,
        value: _.get(row, 'id', 0),
      };
    });
    setData(inputData);
    setOptions(newData);
  };

  const fetchData = () => {
    setIsLoading(true);
    dispatch(loadInventoryLocations())
      .unwrap()
      .then(data => {
        saveDataToState(data.results);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [inputValue]);

  const selectedOption =
    options.find((v, i) => {
      return v.value == value;
    }) || null;

  return (
    <Autocomplete
      disablePortal
      loading={isLoading}
      value={selectedOption}
      inputValue={inputValue}
      disabled={disabled}
      options={options}
      isOptionEqualToValue={(option, value) => {
        return option.value === value.value;
      }}
      getOptionLabel={option => {
        return option ? option.label : '';
      }}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      onBlur={onBlur}
      onChange={(e, opt) => {
        const inventoryLocationId = opt ? (opt.value ?? '') : '';
        e.target = { id: `${name}-autocomplete-input`, name, value: inventoryLocationId };
        onChange(e, inventoryLocationId);
      }}
      onInputChange={(e, value) => {
        setInputValue(value);
      }}
      renderInput={params => {
        return (
          <TextField
            id={`${name}-autocomplete-input`}
            {...params}
            required={required || false}
            fullWidth={fullWidth || false}
            name={name}
            size={size || 'small'}
            label={label}
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: isLoading ? <CircularProgress color="inherit" size={20} /> : params.InputProps.endAdornment,
            }}
          />
        );
      }}
    />
  );
}

export default InventoryLocationAutocomplete;
